import { IWfHeadingProps, WfHeading, IFontSizeResponsiveMap } from "src/components-mui/base/wf-heading/wf-heading";

const H1_FONT_SIZE: IFontSizeResponsiveMap = {
    xs: "4xl",
    sm: "4xl",
    md: "5xl",
};

const H2_FONT_SIZE: IFontSizeResponsiveMap = {
    xs: "3xl",
    sm: "3xl",
    md: "4xl",
};

const H3_FONT_SIZE: IFontSizeResponsiveMap = {
    xs: "2xl",
    sm: "2xl",
    md: "3xl",
};

const getHeadlineProps = (titleAsH1: boolean): Pick<IWfHeadingProps, "component" | "fontSize"> => {
    return titleAsH1
        ? {
              component: "h1",
              fontSize: H1_FONT_SIZE,
          }
        : {
              component: "h2",
              fontSize: H2_FONT_SIZE,
          };
};

const getTitleProps = (titleAsH2: boolean): Pick<IWfHeadingProps, "component" | "fontSize" | "sx"> => {
    return titleAsH2
        ? {
              component: "h2",
              fontSize: H2_FONT_SIZE,
              sx: { mb: [2, 3, 4] },
          }
        : {
              component: "h3",
              fontSize: H3_FONT_SIZE,
              sx: { mb: [2, 2, 3] },
          };
};

interface IModuleHeadlineProps extends Omit<IWfHeadingProps, "component" | "fontSize"> {
    titleAsH1?: boolean;
}

export const ModulePrimaryHeadline = ({ titleAsH1 = false, ...props }: IModuleHeadlineProps) => {
    return <WfHeading {...getHeadlineProps(titleAsH1)} {...props} />;
};

interface IModuleSecondaryHeadlineProps extends Omit<IWfHeadingProps, "component" | "fontSize"> {
    titleAsH2: boolean;
}

export const ModuleSecondaryHeadline = ({ titleAsH2, ...props }: IModuleSecondaryHeadlineProps) => (
    <WfHeading {...getTitleProps(titleAsH2)} {...props} />
);
